<template>
    <li class="col-span-1 bg-white border border-gray-200 rounded-lg shadow divide-y divide-gray-200">
        <div class="w-full flex items-center justify-between p-6 space-x-6">
            <div class="flex-1 truncate">
                <h2 class="text-md tracking-widest uppercase font-bold text-gray-700">Purchases Info</h2>
                <div class="mt-2">
                    <p class="mt-1 text-gray-500 text-sm truncate">{{ activeLicences.length }} Active Product Licences</p>
                    <p class="mt-1 text-gray-500 text-sm truncate">{{ activeCredits.length }} Active Product Credits</p>
                </div>
            </div>
        </div>
        <div>
            <div class="-mt-px flex divide-x divide-gray-200">
                <div class="w-0 flex-1 flex">
                    <a href="#" @click.prevent="productLicences" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                        <BookOpenIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                        <span class="ml-3">View Product Licences</span>
                    </a>
                </div>
                <div class="-ml-px w-0 flex-1 flex">
                    <a href="#" @click.prevent="productCredits" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                        <BanknotesIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                        <span class="ml-3">{{ additionals.credits.length }} Product Credits</span>
                    </a>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import { BookOpenIcon, BanknotesIcon } from "@heroicons/vue/24/outline"
import { useRouter } from "vue-router"
import { computed } from "vue";
import { useStore } from "vuex";

export default {
    name: "EmptySubscriptionBlock",
    components: {
        BookOpenIcon,
        BanknotesIcon
    },
    props: {
        user: {
            type: Object,
            required: true,
        }
    },
    setup(props, context) {
        const store = useStore()
        const vueRouter = useRouter()
        const additionals = computed(() => store.state.userAdditionals)

        const activeLicences = computed(() => store.state.userAdditionals.licences.filter((item) => item.active))
        const activeCredits = computed(() => store.state.userAdditionals.credits.filter((item) => !item.deleted_at))

        const productLicences = () => {
            context.emit('viewLicences')
        }

        const productCredits = () => {
            context.emit('viewCredits')
        }

        return {
            productCredits,
            productLicences,
            additionals,
            activeLicences,
            activeCredits,
        }
    }
}
</script>

<style scoped>

</style>
